/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-46de7b2e.js';
import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import React, { useRef, useMemo } from 'react';
import { i as isObject_1 } from '../_chunks/dep-88cd50bf.js';
import { p as pick_1 } from '../_chunks/dep-4f1e1217.js';
import classNames from 'classnames';
import { Input } from '../input/index.js';
import { Loading } from '../loading/index.js';
import useConfig from '../hooks/useConfig.js';
import useControlled from '../hooks/useControlled.js';
import '../_chunks/dep-2acfafca.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-ca64038e.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-c1f93350.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-33ffecad.js';
import '../_chunks/dep-29cb89ad.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-e73d1b75.js';
import '../_chunks/dep-c8399d32.js';
import '../_chunks/dep-e285f2f8.js';
import '../input/Input.js';
import '../_chunks/dep-92728dc5.js';
import 'tdesign-icons-react';
import '../_util/useLayoutEffect.js';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-6c5254c6.js';
import '../_util/easing.js';
import '../_util/forwardRefWithStatics.js';
import 'hoist-non-react-statics';
import '../hooks/useGlobalIcon.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../input/InputGroup.js';
import '../locale/LocalReceiver.js';
import '../config-provider/index.js';
import '../config-provider/ConfigProvider.js';
import '../input/defaultProps.js';
import '../_util/parseTNode.js';
import '../input/useLengthLimit.js';
import '../_common/js/log/index.js';
import '../_common/js/log/log.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-fd3498b6.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../_chunks/dep-0e15088f.js';
import '../_chunks/dep-f721d103.js';
import '../_chunks/dep-4559db64.js';
import '../_chunks/dep-c00532d4.js';
import '../_util/noop.js';
import '../input/style/css.js';
import '../input/type.js';
import '../loading/Loading.js';
import '../common/Portal.js';
import 'react-dom';
import '../loading/gradient.js';
import '../hooks/useDomRefCallback.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../_chunks/dep-e0370ebe.js';
import '../loading/style/css.js';
import '../loading/type.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var COMMON_PROPERTIES = ["status", "clearable", "disabled", "label", "placeholder", "readonly", "suffix", "suffixIcon", "onPaste", "onEnter", "onMouseenter", "onMouseleave"];
var DEFAULT_KEYS = {
  label: "label",
  value: "value"
};
function getInputValue(value, keys) {
  var iKeys = keys || DEFAULT_KEYS;
  return isObject_1(value) ? value[iKeys.label] : value;
}
function useSingle(props) {
  var value = props.value,
    keys = props.keys,
    loading = props.loading,
    disabled = props.disabled;
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var inputRef = useRef();
  var _useControlled = useControlled(props, "inputValue", props.onInputChange),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    inputValue = _useControlled2[0],
    setInputValue = _useControlled2[1];
  var showLoading = useMemo(function () {
    return !disabled && loading;
  }, [loading, disabled]);
  var commonInputProps = _objectSpread(_objectSpread({}, pick_1(props, COMMON_PROPERTIES)), {}, {
    suffixIcon: showLoading ? /* @__PURE__ */React.createElement(Loading, {
      loading: true,
      size: "small"
    }) : props.suffixIcon
  });
  var onInnerClear = function onInnerClear(context) {
    var _context$e, _props$onClear;
    context === null || context === void 0 ? void 0 : (_context$e = context.e) === null || _context$e === void 0 ? void 0 : _context$e.stopPropagation();
    (_props$onClear = props.onClear) === null || _props$onClear === void 0 ? void 0 : _props$onClear.call(props, context);
    setInputValue("", {
      trigger: "clear"
    });
  };
  var onInnerInputChange = function onInnerInputChange(value2, context) {
    if (props.allowInput) {
      setInputValue(value2, _objectSpread(_objectSpread({}, context), {}, {
        trigger: "input"
      }));
    }
  };
  var renderSelectSingle = function renderSelectSingle(popupVisible) {
    var _props$inputProps, _classNames;
    var singleValueDisplay = !props.multiple ? props.valueDisplay : null;
    var displayedValue = popupVisible && props.allowInput ? inputValue : getInputValue(value, keys);
    return /* @__PURE__ */React.createElement(Input, _objectSpread(_objectSpread(_objectSpread({
      ref: inputRef
    }, commonInputProps), {}, {
      autoWidth: props.autoWidth,
      placeholder: singleValueDisplay ? "" : props.placeholder,
      value: singleValueDisplay ? " " : displayedValue,
      label: /* @__PURE__ */React.createElement(React.Fragment, null, props.label, singleValueDisplay),
      onChange: onInnerInputChange,
      readonly: !props.allowInput,
      onClear: onInnerClear,
      onFocus: function onFocus(val, context) {
        var _props$onFocus;
        (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 ? void 0 : _props$onFocus.call(props, value, _objectSpread(_objectSpread({}, context), {}, {
          inputValue: val
        }));
      },
      onEnter: function onEnter(val, context) {
        var _props$onEnter;
        (_props$onEnter = props.onEnter) === null || _props$onEnter === void 0 ? void 0 : _props$onEnter.call(props, value, _objectSpread(_objectSpread({}, context), {}, {
          inputValue: val
        }));
      }
    }, props.inputProps), {}, {
      inputClass: classNames((_props$inputProps = props.inputProps) === null || _props$inputProps === void 0 ? void 0 : _props$inputProps.className, (_classNames = {}, _defineProperty(_classNames, "".concat(classPrefix, "-input--focused"), popupVisible), _defineProperty(_classNames, "".concat(classPrefix, "-is-focused"), popupVisible), _classNames))
    }));
  };
  return {
    inputRef: inputRef,
    commonInputProps: commonInputProps,
    singleInputValue: inputValue,
    onInnerClear: onInnerClear,
    renderSelectSingle: renderSelectSingle
  };
}

export { useSingle as default };
//# sourceMappingURL=useSingle.js.map
